import { useState } from 'react';

interface UseStepperNavigationProps {
  totalSteps: number;
  initialStep?: number;
}

export const useStepperNavigation = ({
  totalSteps,
  initialStep = 0,
}: UseStepperNavigationProps) => {
  const [activeStep, setActiveStep] = useState(initialStep);

  const numOfSteps = () => {
    return totalSteps;
  };

  const isLastStep = () => {
    return activeStep === totalSteps - 1;
  };

  const isFirstStep = () => {
    return activeStep === 0;
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) =>
      Math.min(prevActiveStep + 1, totalSteps - 1)
    );
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => Math.max(prevActiveStep - 1, 0));
  };

  const goToStep = (step: number) => {
    if (step >= 0 && step < totalSteps) {
      setActiveStep(step);
    }
  };

  const goToLastStep = () => {
    setActiveStep(totalSteps - 1);
  };

  const resetToFirstStep = () => {
    setActiveStep(0);
  };

  return {
    activeStep,
    setActiveStep,
    isLastStep,
    isFirstStep,
    handleNext,
    handleBack,
    goToStep,
    resetToFirstStep,
    goToLastStep,
    numOfSteps,
  };
};
